<template>
    <v-card
        max-width="1080"
        flat
    >
        <v-card-text>
            <v-row v-if="$vuetify.breakpoint.smAndUp">
                <v-col cols="12">
                    <v-card-title>
                        Alert Preferences
                    </v-card-title>
                    <v-card-subtitle>
                        {{ ticketAlertText }}
                    </v-card-subtitle>
                </v-col>
                <v-col cols="12">
                    <v-simple-table
                        class="table"
                    >
                        <thead
                    style="background-color:var(--ll-surface-subtle);"
                        >
                            <tr>
                                <th class="font-weight-bold text-left">
                                    Ticket Type
                                </th>
                                <th class="font-weight-bold text-left">
                                    In App
                                </th>
                                <th class="font-weight-bold text-left">
                                    Email
                                </th>
                                <th
                                    v-if="ticketAlertSms"
                                    class="font-weight-bold text-left"
                                >
                                    SMS/TEXT
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in items"
                                :key="item.name"
                            >
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    <v-checkbox
                                        v-model="item.inapp.value"
                                        color="primary"
                                        :ripple="false"
                                        hide-details
                                        class="mt-0"
                                    />
                                </td>
                                <td>
                                    <v-checkbox
                                        v-model="item.email.value"
                                        color="primary"
                                        :ripple="false"
                                        hide-details
                                        class="mt-0"
                                    />
                                </td>
                                <td v-if="ticketAlertSms">
                                    <v-checkbox
                                        v-model="item.sms.value"
                                        color="primary"
                                        :ripple="false"
                                        hide-details
                                        class="mt-0"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col
                    cols="12"
                    sm="5"
                    md="auto"
                    align-self="center"
                >
                    <v-card-title>
                        Alert Sound Settings
                    </v-card-title>
                </v-col>
                <v-col
                    cols="7"
                    md="8"
                    align-self="center"
                >
                    <v-switch
                        v-model="enabled"
                        label="You can enable an alarm sound by selecting any ticket type for In App alerts."
                        inset
                    />
                </v-col>
            </v-row>
            <div
                v-else
                class="mb-5"
            >
                <v-card-subtitle class="mobile-subtitle">
                    {{ ticketAlertText }}
                </v-card-subtitle>
                <v-row
                    v-for="item in items"
                    :key="item.name"
                >
                    <v-col
                        cols="12"
                        xs="12"
                            style="border-top: 1px solid var(--ll-divider);"
                    >
                        <v-card-text class="mobile-title">
                            {{ item.name }}
                        </v-card-text>
                        <v-col
                            cols="12"
                            class="py-0 pl-5"
                        >
                            <v-checkbox
                                v-model="item.inapp.value"
                                color="primary"
                                :ripple="false"
                                hide-details
                                dense
                            >
                                <template v-slot:label>
                                    <span style="color: rgba(0,0,0,.92);">In App</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col
                            cols="12"
                            class="py-0 pl-5"
                        >
                            <v-checkbox
                                v-model="item.email.value"
                                color="primary"
                                :ripple="false"
                                hide-details
                                dense
                            >
                                <template v-slot:label>
                                    <span style="color: rgba(0,0,0,.92);">Email</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col
                            v-if="ticketAlertSms"
                            cols="12"
                            class="py-0 pl-5"
                        >
                            <v-checkbox
                                v-model="item.sms"
                                color="primary"
                                :ripple="false"
                                hide-details
                                dense
                            >
                                <template v-slot:label>
                                    <span style="color: rgba(0,0,0,.92);">SMS/TEXT</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-col>
                </v-row>
            </div>
            <v-divider />
            <v-col
                v-if="!$vuetify.breakpoint.smAndUp"
                cols="12"
                sm="12"
                md="auto"
                align-self="center"
            >
                <v-card-title class="p-0">
                    Alert Sound Settings
                </v-card-title>
            </v-col>
            <v-col
                v-if="!$vuetify.breakpoint.smAndUp"
                cols="12"
                md="12"
                align-self="center"
                class="py-0"
            >
                <v-switch
                    v-model="enabled"
                    label="You can enable an alarm sound by selecting any ticket type for In App alerts."
                    inset
                />
            </v-col>
            <v-divider v-if="!$vuetify.breakpoint.smAndUp" />
            <v-col
                v-show="enabled"
                class="col col-md-12 my-5 mx-0"
            >
                Note : Alarm sounds may not play until you actively interact with the web page (click, tap, etc). For Chrome, this is a browser-imposed policy.
            </v-col>
            <v-row
                v-show="enabled"
                class="mx-1"
            >
                <v-col
                    cols="12"
                    md="6"
                >
                    <div class="">
                        Alarm Type
                    </div>
                    <div class="radio-btn-group">
                        <v-radio-group v-model="alarmWhich">
                            <v-radio
                                label="Alarm 1"
                                value="1"
                            />
                            <v-radio
                                label="Alarm 2"
                                value="2"
                            />
                            <v-radio
                                label="Alarm 3"
                                value="3"
                            />
                        </v-radio-group>
                        <div
                            class="icons-align"
                            style="height: 82px;"
                        >
                            <v-icon
                                v-show="activePlaySound != 'Alarm_1'"
                                @click="playSound('Alarm_1')"
                            >
                                volume_up
                            </v-icon>
                            <v-icon
                                v-show="activePlaySound == 'Alarm_1'"
                                @click="stopPlaySound"
                            >
                                volume_off
                            </v-icon>
                            <v-icon
                                v-show="activePlaySound != 'Alarm_2'"
                                @click="playSound('Alarm_2')"
                            >
                                volume_up
                            </v-icon>
                            <v-icon
                                v-show="activePlaySound == 'Alarm_2'"
                                @click="stopPlaySound"
                            >
                                volume_off
                            </v-icon>
                            <v-icon
                                v-show="activePlaySound != 'Alarm_3'"
                                @click="playSound('Alarm_3')"
                            >
                                volume_up
                            </v-icon>
                            <v-icon
                                v-show="activePlaySound == 'Alarm_3'"
                                @click="stopPlaySound"
                            >
                                volume_off
                            </v-icon>
                        </div>
                    </div>
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                >
                    <div class="">
                        Alarm Trigger
                    </div>
                    <div class="radio-btn-group">
                        <v-radio-group v-model="alarmWhen">
                            <v-radio
                                label="Any Alerts"
                                value="ALWAYS"
                            />
                            <v-radio
                                label="New Alerts Only"
                                value="NEW"
                            />
                        </v-radio-group>
                        <div class="icons-align">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon
                                        color="#1976D2"
                                        v-on="on"
                                    >
                                        info_outline
                                    </v-icon>
                                </template>
                                <span>Description of any alert</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon
                                        color="#1976D2"
                                        v-on="on"
                                    >
                                        info_outline
                                    </v-icon>
                                </template>
                                <span>Description of new alert</span>
                            </v-tooltip>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <div style="display: none;">
                <audio
                    ref="alertRadio1"
                    src="WebTMS_alarm1.mp3"
                    type="audio/mpeg"
                    loop
                    mute
                />
                <audio
                    ref="alertRadio2"
                    src="WebTMS_alarm2.mp3"
                    type="audio/mpeg"
                    loop
                    mute
                />
                <audio
                    ref="alertRadio3"
                    src="WebTMS_alarm3.mp3"
                    type="audio/mpeg"
                    loop
                    mute
                />
            </div>
        </v-card-text>
        <v-card-actions class="mt-10 ">
            <v-row
                :class="{ 'bottomNav': !this.$vuetify.breakpoint.smAndUp }"
            >
                <v-col
                    cols="auto"
                >
                    <v-btn
                        color="primary"
                        outlined
                        light
                        @click="$router.go(-1)"
                    >
                        Cancel
                    </v-btn>
                </v-col>
                <v-col
                    cols="auto"
                >
                    <v-btn
                        color="primary"
                        dark
                        @click.once="updateAlertSettings"
                    >
                        Update
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import { getUserOption } from '../../utils/options';
import { hasPermission } from '@/utils/permissions';
import {isTruthy} from '@/utils/isTruthy';

export default {
    data() {
        return {
            alarmWhich: '1',
            alarmWhen: 'NEW',
            enabled: this.$store.state.alertsAudioOn,
            useroptions: this.$store.getters.userOptions,
            activePlaySound: null,
            ticketAlertSms: hasPermission('TICKET_ALERTS--SMS')
        };
    },
    computed: {
        items() {
            return [
                {
                    name: 'Emergency',
                    inapp: { option: 'TICKET_ALERT_EMERGENCY_UI', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_UI') },
                    email: { option: 'TICKET_ALERT_EMERGENCY_EMAIL', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_EMAIL') },
                    sms: { option: 'TICKET_ALERT_EMERGENCY_SMS', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_SMS') },
                },
                {
                    name: 'Damage',
                    inapp: { option: 'TICKET_ALERT_DAMAGE_UI', value: this.getOptionValue('TICKET_ALERT_DAMAGE_UI') },
                    email: { option: 'TICKET_ALERT_DAMAGE_EMAIL', value: this.getOptionValue('TICKET_ALERT_DAMAGE_EMAIL') },
                    sms: { option: 'TICKET_ALERT_DAMAGE_SMS', value: this.getOptionValue('TICKET_ALERT_DAMAGE_SMS') },
                },
                {
                    name: 'Design',
                    inapp: { option: 'TICKET_ALERT_DESIGN_UI', value: this.getOptionValue('TICKET_ALERT_DESIGN_UI') },
                    email: { option: 'TICKET_ALERT_DESIGN_EMAIL', value: this.getOptionValue('TICKET_ALERT_DESIGN_EMAIL') },
                    sms: { option: 'TICKET_ALERT_DESIGN_SMS', value: this.getOptionValue('TICKET_ALERT_DESIGN_SMS') },
                },
                {
                    name: 'Cancel',
                    inapp: { option: 'TICKET_ALERT_CANCEL_UI', value: this.getOptionValue('TICKET_ALERT_CANCEL_UI') },
                    email: { option: 'TICKET_ALERT_CANCEL_EMAIL', value: this.getOptionValue('TICKET_ALERT_CANCEL_EMAIL') },
                    sms: { option: 'TICKET_ALERT_CANCEL_SMS', value: this.getOptionValue('TICKET_ALERT_CANCEL_SMS') },
                },
                {
                    name: 'Late',
                    inapp: { option: 'TICKET_ALERT_LATE_UI', value: this.getOptionValue('TICKET_ALERT_LATE_UI') },
                    email: { option: 'TICKET_ALERT_LATE_EMAIL', value: this.getOptionValue('TICKET_ALERT_LATE_EMAIL') },
                    sms: { option: 'TICKET_ALERT_LATE_SMS', value: this.getOptionValue('TICKET_ALERT_LATE_SMS') },
                },
                {
                    name: 'On Escalated',
                    inapp: { option: 'TICKET_ALERT_ESCALATED_UI', value: this.getOptionValue('TICKET_ALERT_ESCALATED_UI') },
                    email: { option: 'TICKET_ALERT_ESCALATED_EMAIL', value: this.getOptionValue('TICKET_ALERT_ESCALATED_EMAIL') },
                    sms: { option: 'TICKET_ALERT_ESCALATED_SMS', value: this.getOptionValue('TICKET_ALERT_ESCALATED_SMS') },
                },
            ];
        },
        ticketAlertText() {
            let alertText = 'Ticket Alerts are generated for certain ticket types. The UI (User Interface) alert will display an alert notification on the Web homepage that must be dismissed. You can also include an E-Mail alert to be sent.';

            if (this.ticketAlertSms) {
                alertText = 'Ticket Alerts are generated for certain ticket types. The UI (User Interface) alert will display an alert notification on the Web homepage that must be dismissed. You can also include an E-Mail and SMS alert to be sent.';
            }
            return  alertText;
        },
    },
    created() {
        if(this.useroptions.length > 0) {
            for(let uo of this.useroptions) {
                if(uo.option === 'UI:alarm-which') {
                    this.alarmWhich = uo.value;
                }
                if(uo.option === 'UI:alarm-when') {
                    this.alarmWhen = uo.value;
                }
                if(uo.option === 'UI:alarm-enabled') {
                    // is the string value true or false?
                    this.enabled =(uo.value === 'true');
                }
            }
        }
    },
    methods: {
        getOptionValue(optionName) {
            let value = '0'; // default to 'false'
            if(this.useroptions.length > 0) {
                for(let uo of this.useroptions) {
                    if(uo.option === optionName) {
                        value = uo.value;
                        break;
                    }
                }
            } else {
                value = getUserOption(optionName);
            }
            return isTruthy(value);
        },
        async updateAlertSettings() {

            let options = [];

            options.push(['TICKET_ALERT_EMERGENCY_UI', this.convertToBit(this.items.filter(item => item.name === 'Emergency')[0].inapp.value)]);
            options.push(['TICKET_ALERT_EMERGENCY_EMAIL', this.convertToBit(this.items.filter(item => item.name === 'Emergency')[0].email.value)]);
            options.push(['TICKET_ALERT_EMERGENCY_SMS', this.convertToBit(this.items.filter(item => item.name === 'Emergency')[0].sms.value)]);

            options.push(['TICKET_ALERT_DAMAGE_UI',  this.convertToBit(this.items.filter(item => item.name === 'Damage')[0].inapp.value)]);
            options.push(['TICKET_ALERT_DAMAGE_EMAIL',  this.convertToBit(this.items.filter(item => item.name === 'Damage')[0].email.value)]);
            options.push(['TICKET_ALERT_DAMAGE_SMS', this.convertToBit(this.items.filter(item => item.name === 'Damage')[0].sms.value)]);

            options.push(['TICKET_ALERT_DESIGN_UI', this.convertToBit(this.items.filter(item => item.name === 'Design')[0].inapp.value)]);
            options.push(['TICKET_ALERT_DESIGN_EMAIL',  this.convertToBit(this.items.filter(item => item.name === 'Design')[0].email.value)]);
            options.push(['TICKET_ALERT_DESIGN_SMS', this.convertToBit(this.items.filter(item => item.name === 'Design')[0].sms.value)]);

            options.push(['TICKET_ALERT_CANCEL_UI',  this.convertToBit(this.items.filter(item => item.name === 'Cancel')[0].inapp.value)]);
            options.push(['TICKET_ALERT_CANCEL_EMAIL',  this.convertToBit(this.items.filter(item => item.name === 'Cancel')[0].email.value)]);
            options.push(['TICKET_ALERT_CANCEL_SMS',  this.convertToBit(this.items.filter(item => item.name === 'Cancel')[0].sms.value)]);

            options.push(['TICKET_ALERT_LATE_UI',  this.convertToBit(this.items.filter(item => item.name === 'Late')[0].inapp.value)]);
            options.push(['TICKET_ALERT_LATE_EMAIL',  this.convertToBit(this.items.filter(item => item.name === 'Late')[0].email.value)]);
            options.push(['TICKET_ALERT_LATE_SMS',  this.convertToBit(this.items.filter(item => item.name === 'Late')[0].sms.value)]);

            options.push(['TICKET_ALERT_ESCALATED_UI',  this.convertToBit(this.items.filter(item => item.name === 'On Escalated')[0].inapp.value)]);
            options.push(['TICKET_ALERT_ESCALATED_EMAIL',  this.convertToBit(this.items.filter(item => item.name === 'On Escalated')[0].email.value)]);
            options.push(['TICKET_ALERT_ESCALATED_SMS',  this.convertToBit(this.items.filter(item => item.name === 'On Escalated')[0].sms.value)]);

            options.push(['UI:alarm-enabled', this.enabled? this.enabled.toString(): ''] );
            options.push(['UI:alarm-when',  this.alarmWhen]);
            options.push(['UI:alarm-which',  this.alarmWhich]);

            try {
                // Save options to backend via store action
                await this.$store.dispatch('updateUserOptions', options);
                this.$store.dispatch('setSnackbar', { text:'Alert preferences updated successfully!' });
                this.$router.push('/profile');
            } catch (error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error.message });
            }
        },
        convertToBoolean(value) {
            if (value === '1') {
                return true;
            }
            return false;
        },
        convertToBit(value) {
            if (value) {
                return '1';
            }
            return '0';
        },
        playSound(type) {
            this.stopPlaySound();
            this.activePlaySound = type;
            switch(type) {
                case 'Alarm_1':
                    this.$refs.alertRadio1?.play();
                    break;
                case 'Alarm_2':
                    this.$refs.alertRadio2?.play();
                    break;
                case 'Alarm_3':
                    this.$refs.alertRadio3?.play();
                    break;
            }
        },
        stopPlaySound() {
            this.activePlaySound = null;
            this.$refs.alertRadio1?.pause();
            this.$refs.alertRadio2?.pause();
            this.$refs.alertRadio3?.pause();
        }
    }
};
</script>

<style scoped>
.table {
    border: 1px solid var(--ll-divider) !important;
}
.table th {
    font-size: 1em !important;
}
.mobile-title {
    font-size: medium;
    font-weight: 500;
    color: var(--ll-text-primary);
    padding: 0 5px;
}
.mobile-subtitle {
    font-size: medium;
    color: var(--ll-text-primary);
    padding-left: 0;
}
.bottomNav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 15px;
    background: var(--ll-surface);
    justify-content: center;
    border-top: 1px solid var(--ll-border);
    margin-top: 1em;
    padding: 8px;
}
.bottomNav .v-btn {
  width: 134px;
  height: 48px;
  padding: 16px;
}
.radio-btn-group {
    display: flex;
}
.icons-align {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 22px 8px;
    height: 50px;
}
.icons-align .v-icon {
    font-size: 18px;
}
</style>
